// extracted by mini-css-extract-plugin
module.exports = {"closeTransitionDuration":".3s","openTransitionDuration":".3s"};